import React from 'react';
import { Link } from 'react-router-dom';

const CommonPageHeader = ({ title, subtitle }) => {
   return (
      <>
         <section className="page__title p-relative tw-flex tw-items-center fix" style={{ background: `url(assets/img/page-title/page-title-1.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
            {/* <div className="slider__shape">
               <img className="shape circle-2" src="/assets/img/icon/slider/circle.png" alt="circle" />
            </div> */}
            <div className="tw-container tw-mx-auto p-relative">
               <div className="tw-flex tw-flex-wrap tw--mx-3">
                  <div className="tw-w-full tw-px-3">
                     <div className="page__title-content mt-100">
                        <h1>{title}</h1>

                        <nav aria-label="breadcrumb">
                           <ol className="breadcrumb tw-flex tw-flex-wrap">
                              <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                              <li className="breadcrumb-item active" aria-current="page">{subtitle}</li>
                           </ol>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default CommonPageHeader;